import React from "react";
import { Table, Icon } from "semantic-ui-react";
import _ from "lodash";

function Fila(props) {
  const servicios = () => {
    switch (props.servicios) {
      case "completa":
        return "C";
      case "completaMoV":
        return props.matinal ? "CM" : props.vespertina ? "CV" : "CMoV";
      case "completaMyV":
        return "CMV";
      case "diasSueltos":
        return "D";
      case "diasSueltosMoV":
        return props.matinal ? "DM" : props.vespertina ? "DV" : "DMoV";
      case "diasSueltosMyV":
        return "DMV";
      default:
        break;
    }
  };

  const dias = item => (
    <Table.Cell textAlign="center" key={`${props.idInscripcion}_${item}`}>
      <Icon name="square outline" size="big" />
    </Table.Cell>
  );

  return [
    <Table.Row key={props.idInscripcion}>
      <Table.Cell content={props.nombre} />
      <Table.Cell content={props.apellido1} />
      <Table.Cell content={props.edad} textAlign="center" />
      <Table.Cell content={props.telefonos} />
      <Table.Cell content={servicios()} textAlign="center" />
      {_.times(props.dias, dias)}
    </Table.Row>,
    <Table.Row key={`${props.idInscripcion}sub`} warning>
      <Table.Cell colSpan={12} content={props.notas} />
    </Table.Row>
  ];
}

export default Fila;



// WEBPACK FOOTER //
// ./src/pages/inscripcionesConfirmadas/listaInscripciones/tablaAsistencias/FilaAsistencias.jsx